import { useStore } from '../store/mst';
import { GetCursorParams } from '../components/shared/MapBase/utils/getMapCursor';
import usePermissions, { Features } from '../permissions/usePermissions';
import ComponentNames from '../permissions/constants/componentNames';

const useCursorProps = () => {
  const store = useStore();
  const { mapView, ui } = store;
  const {
    canAssignStopsToRoutes,
  } = usePermissions(Features.Orders, ComponentNames.DraggableVisitsLayer);


  const cursorProps: GetCursorParams = {
    isDragging: !!mapView.draggingVisit,
    cursorTooltip: mapView.cursorTooltip,
    isDrawingLassoMode: mapView.isDrawingLassoMode,
    isLassoMode: mapView.isLassoMode,
    isHoveringWithinLasso: mapView.isHoveringWithinLasso,
    hoveredEditHandleType: mapView.hoveredEditHandleType,
    isPicking: !!ui.hoveredRoute || !!ui.hoveredDriver,
    canMoveStopsPermission: canAssignStopsToRoutes,
    hoveredMarker: !!mapView.hoveredMarker || !!ui.hoveredVisit || !!ui.hoveredRouteEvent,
    isDrawMode: mapView.isDrawMode,
  };

  return cursorProps;
};

export default useCursorProps;
